var _path, _path2, _path3, _path4, _rect, _rect2, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _circle, _circle2, _circle3, _circle4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPictogramBeaconCashCode40(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.1111 4.375H13.9584C12.5202 4.375 11.3542 5.54092 11.3542 6.97915V33.0206C11.3542 34.4588 12.5202 35.6248 13.9584 35.6248H26.1111C27.5493 35.6248 28.7152 34.4588 28.7152 33.0206V6.97915C28.7152 5.54092 27.5493 4.375 26.1111 4.375Z",
    fill: "white",
    stroke: "#1E1E1E",
    strokeWidth: 1.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.1111 4.375H13.9584C12.5202 4.375 11.3542 5.54092 11.3542 6.97915V33.0206C11.3542 34.4588 12.5202 35.6248 13.9584 35.6248H26.1111C27.5493 35.6248 28.7152 34.4588 28.7152 33.0206V6.97915C28.7152 5.54092 27.5493 4.375 26.1111 4.375Z",
    stroke: "#1E1E1E",
    strokeWidth: 1.2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.354 31.1611H28.715V33.0212C28.715 34.4595 27.5491 35.6254 26.1108 35.6254H13.9582C12.5199 35.6254 11.354 34.4595 11.354 33.0212V31.1611Z",
    fill: "#FAEC20",
    stroke: "#1E1E1E",
    strokeWidth: 1.2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0348 34.5085C20.6601 34.5085 21.1671 34.0088 21.1671 33.3924C21.1671 32.776 20.6601 32.2764 20.0348 32.2764C19.4095 32.2764 18.9026 32.776 18.9026 33.3924C18.9026 34.0088 19.4095 34.5085 20.0348 34.5085Z",
    fill: "white",
    stroke: "#1E1E1E",
    strokeWidth: 1.2
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 8.75,
    y: 9.58301,
    width: 22.5693,
    height: 7.81244,
    rx: 1.25,
    fill: "white",
    stroke: "#1E1E1E",
    strokeWidth: 1.2
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 13.9583,
    y: 20.8682,
    width: 12.1527,
    height: 6.07634,
    rx: 1.25,
    fill: "white",
    stroke: "#1E1E1E",
    strokeWidth: 1.2
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3542 11.3193L13.9584 15.2256",
    stroke: "#1E1E1E",
    strokeWidth: 1.2
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9585 11.3193L11.3543 15.2256",
    stroke: "#1E1E1E",
    strokeWidth: 1.2
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0435 11.3193L17.6476 15.2256",
    stroke: "#1E1E1E",
    strokeWidth: 1.2
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6475 11.3193L15.0433 15.2256",
    stroke: "#1E1E1E",
    strokeWidth: 1.2
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7324 11.3193L21.3366 15.2256",
    stroke: "#1E1E1E",
    strokeWidth: 1.2
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M21.3367 11.3193L18.7325 15.2256",
    stroke: "#1E1E1E",
    strokeWidth: 1.2
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4219 11.3193L25.026 15.2256",
    stroke: "#1E1E1E",
    strokeWidth: 1.2
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M25.0261 11.3193L22.422 15.2256",
    stroke: "#1E1E1E",
    strokeWidth: 1.2
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M26.1108 11.3193L28.715 15.2256",
    stroke: "#1E1E1E",
    strokeWidth: 1.2
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M28.7148 11.3193L26.1107 15.2256",
    stroke: "#1E1E1E",
    strokeWidth: 1.2
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16.6071,
    cy: 23.9061,
    r: 0.868049,
    fill: "#1E1E1E"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 18.8358,
    cy: 23.9061,
    r: 0.868049,
    fill: "#1E1E1E"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 21.0641,
    cy: 23.9061,
    r: 0.868049,
    fill: "#1E1E1E"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 23.2929,
    cy: 23.9061,
    r: 0.868049,
    fill: "#1E1E1E"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPictogramBeaconCashCode40);
export default __webpack_public_path__ + "static/media/pictogramBeaconCashCode40.9b0b03082507c47243efd565eca9f1a2.svg";
export { ForwardRef as ReactComponent };